import React, { useRef } from "react";
import { useReducedMotion } from "../lib/useReducedMotion";

/**
 * Lightweight 3D tilt with no external deps. Mouse-driven; respects
 * prefers-reduced-motion. Max 6° tilt + soft cyan glow on hover.
 */
export const Tilt = ({ children, max = 6, className = "", "data-testid": testId }) => {
    const ref = useRef(null);
    const reduced = useReducedMotion();

    const handleMove = (e) => {
        if (reduced || !ref.current) return;
        const el = ref.current;
        const r = el.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5; // -0.5..0.5
        const y = (e.clientY - r.top) / r.height - 0.5;
        const rx = (-y * max).toFixed(2);
        const ry = (x * max).toFixed(2);
        el.style.transform = `perspective(900px) rotateX(${rx}deg) rotateY(${ry}deg)`;
        el.style.setProperty("--tilt-mx", `${(x + 0.5) * 100}%`);
        el.style.setProperty("--tilt-my", `${(y + 0.5) * 100}%`);
    };

    const reset = () => {
        if (!ref.current) return;
        ref.current.style.transform = "perspective(900px) rotateX(0deg) rotateY(0deg)";
    };

    return (
        <div
            ref={ref}
            onMouseMove={handleMove}
            onMouseLeave={reset}
            className={`tilt-card transition-transform duration-200 ease-out will-change-transform ${className}`}
            data-testid={testId}
        >
            {children}
        </div>
    );
};

export default Tilt;
